import * as api from '../api/buildingPermit';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'PROCESS-MANAGER';

export const FETCH_BUILDING_PERMIT_CONFIGURATIONS = createRequestTypes(
  `${prefix}/FETCH_BUILDING_PERMIT_CONFIGURATIONS`,
);

export const fetchBuildingPermitConfigurations = makeApiActionCreatorV3(
  api.fetchBuildingPermitConfigurations,
  FETCH_BUILDING_PERMIT_CONFIGURATIONS[START],
  FETCH_BUILDING_PERMIT_CONFIGURATIONS[SUCCESS],
  FETCH_BUILDING_PERMIT_CONFIGURATIONS[ERROR],
);

export const INSERT_BUILDING_PERMIT_CONFIGURATION = createRequestTypes(
  `${prefix}/INSERT_BUILDING_PERMIT_CONFIGURATION`,
);

export const insertBuildingPermitConfiguration = makeApiActionCreatorV3(
  api.insertBuildingPermitConfiguration,
  INSERT_BUILDING_PERMIT_CONFIGURATION[START],
  INSERT_BUILDING_PERMIT_CONFIGURATION[SUCCESS],
  INSERT_BUILDING_PERMIT_CONFIGURATION[ERROR],
);

export const FETCH_BUILDING_PERMIT_CONFIGURATION = createRequestTypes(
  `${prefix}/FETCH_BUILDING_PERMIT_CONFIGURATION`,
);

export const fetchBuildingPermitConfiguration = makeApiActionCreatorV3(
  api.fetchBuildingPermitConfiguration,
  FETCH_BUILDING_PERMIT_CONFIGURATION[START],
  FETCH_BUILDING_PERMIT_CONFIGURATION[SUCCESS],
  FETCH_BUILDING_PERMIT_CONFIGURATION[ERROR],
);

export const UPDATE_BUILDING_PERMIT_CONFIGURATION = createRequestTypes(
  `${prefix}/UPDATE_BUILDING_PERMIT_CONFIGURATION`,
);

export const updateBuildingPermitConfiguration = makeApiActionCreatorV3(
  api.updateBuildingPermitConfiguration,
  UPDATE_BUILDING_PERMIT_CONFIGURATION[START],
  UPDATE_BUILDING_PERMIT_CONFIGURATION[SUCCESS],
  UPDATE_BUILDING_PERMIT_CONFIGURATION[ERROR],
);

export const DOWNLOAD_BUILDING_PERMIT_CONFIG_FILE = createRequestTypes(
  `${prefix}/DOWNLOAD_BUILDING_PERMIT_CONFIG_FILE`,
);

export const downloadBuildingPermitConfigFile = makeApiActionCreatorV3(
  api.downloadBuildingPermitConfigFile,
  DOWNLOAD_BUILDING_PERMIT_CONFIG_FILE[START],
  DOWNLOAD_BUILDING_PERMIT_CONFIG_FILE[SUCCESS],
  DOWNLOAD_BUILDING_PERMIT_CONFIG_FILE[ERROR],
);

export const DOWNLOAD_BUILDING_PERMIT_IMPORT_FILE = createRequestTypes(
  `${prefix}/DOWNLOAD_BUILDING_PERMIT_IMPORT_FILE`,
);

export const downloadBuildingPermitImportFile = makeApiActionCreatorV3(
  api.downloadBuildingPermitImportFile,
  DOWNLOAD_BUILDING_PERMIT_IMPORT_FILE[START],
  DOWNLOAD_BUILDING_PERMIT_IMPORT_FILE[SUCCESS],
  DOWNLOAD_BUILDING_PERMIT_IMPORT_FILE[ERROR],
);

export const FETCH_BUILDING_PERMIT_FIELDS = createRequestTypes(
  `${prefix}/FETCH_BUILDING_PERMIT_FIELDS`,
);

export const fetchBuildingPermitFields = makeApiActionCreatorV3(
  api.fetchBuildingPermitFields,
  FETCH_BUILDING_PERMIT_FIELDS[START],
  FETCH_BUILDING_PERMIT_FIELDS[SUCCESS],
  FETCH_BUILDING_PERMIT_FIELDS[ERROR],
);

export const DELETE_BUILDING_PERMIT_CONFIGURATION = createRequestTypes(
  `${prefix}/DELETE_BUILDING_PERMIT_CONFIGURATION`,
);

export const deleteBuildingPermitConfiguration = makeApiActionCreatorV3(
  api.deleteBuildingPermitConfiguration,
  DELETE_BUILDING_PERMIT_CONFIGURATION[START],
  DELETE_BUILDING_PERMIT_CONFIGURATION[SUCCESS],
  DELETE_BUILDING_PERMIT_CONFIGURATION[ERROR],
);

export const FETCH_BUILDING_PERMIT_IMPORTS = createRequestTypes(
  `${prefix}/FETCH_BUILDING_PERMIT_IMPORTS`,
);

export const fetchBuildingPermitImports = makeApiActionCreatorV3(
  api.fetchBuildingPermitImports,
  FETCH_BUILDING_PERMIT_IMPORTS[START],
  FETCH_BUILDING_PERMIT_IMPORTS[SUCCESS],
  FETCH_BUILDING_PERMIT_IMPORTS[ERROR],
);

export const CREATE_BUILDING_PERMIT_IMPORT = createRequestTypes(
  `${prefix}/CREATE_BUILDING_PERMIT_IMPORT`,
);

export const createBuildingPermitImport = makeApiActionCreatorV3(
  api.createBuildingPermitImport,
  CREATE_BUILDING_PERMIT_IMPORT[START],
  CREATE_BUILDING_PERMIT_IMPORT[SUCCESS],
  CREATE_BUILDING_PERMIT_IMPORT[ERROR],
);

export const FETCH_BUILDING_PERMIT_IMPORT = createRequestTypes(
  `${prefix}/FETCH_BUILDING_PERMIT_IMPORT`,
);

export const fetchBuildingPermitImport = makeApiActionCreatorV3(
  api.fetchBuildingPermitImport,
  FETCH_BUILDING_PERMIT_IMPORT[START],
  FETCH_BUILDING_PERMIT_IMPORT[SUCCESS],
  FETCH_BUILDING_PERMIT_IMPORT[ERROR],
);

export const UNDO_BUILDING_PERMIT_IMPORT = createRequestTypes(
  `${prefix}/UNDO_BUILDING_PERMIT_IMPORT`,
);

export const undoBuildingPermitImport = makeApiActionCreatorV3(
  api.undoBuildingPermitImport,
  UNDO_BUILDING_PERMIT_IMPORT[START],
  UNDO_BUILDING_PERMIT_IMPORT[SUCCESS],
  UNDO_BUILDING_PERMIT_IMPORT[ERROR],
);

export const ANALYZE_BUILDING_PERMIT_IMPORT = createRequestTypes(
  `${prefix}/ANALYZE_BUILDING_PERMIT_IMPORT`,
);

export const analyzeBuildingPermitImport = makeApiActionCreatorV3(
  api.analyzeBuildingPermitImport,
  ANALYZE_BUILDING_PERMIT_IMPORT[START],
  ANALYZE_BUILDING_PERMIT_IMPORT[SUCCESS],
  ANALYZE_BUILDING_PERMIT_IMPORT[ERROR],
);

export const MATCH_BUILDING_PERMIT_IMPORT = createRequestTypes(
  `${prefix}/MATCH_BUILDING_PERMIT_IMPORT`,
);

export const matchBuildingPermitImport = makeApiActionCreatorV3(
  api.matchBuildingPermitImport,
  MATCH_BUILDING_PERMIT_IMPORT[START],
  MATCH_BUILDING_PERMIT_IMPORT[SUCCESS],
  MATCH_BUILDING_PERMIT_IMPORT[ERROR],
);

export const IMPORT_BUILDING_PERMIT_IMPORT = createRequestTypes(
  `${prefix}/IMPORT_BUILDING_PERMIT_IMPORT`,
);

export const importBuildingPermitImport = makeApiActionCreatorV3(
  api.importBuildingPermitImport,
  IMPORT_BUILDING_PERMIT_IMPORT[START],
  IMPORT_BUILDING_PERMIT_IMPORT[SUCCESS],
  IMPORT_BUILDING_PERMIT_IMPORT[ERROR],
);

export const FETCH_BUILDING_PERMIT_IMPORT_MATCHED = createRequestTypes(
  `${prefix}/FETCH_BUILDING_PERMIT_IMPORT_MATCHED`,
);

export const fetchBuildingPermitImportMatched = makeApiActionCreatorV3(
  api.fetchBuildingPermitImportMatched,
  FETCH_BUILDING_PERMIT_IMPORT_MATCHED[START],
  FETCH_BUILDING_PERMIT_IMPORT_MATCHED[SUCCESS],
  FETCH_BUILDING_PERMIT_IMPORT_MATCHED[ERROR],
);

export const FETCH_BUILDING_PERMIT_IMPORT_UNMATCHED = createRequestTypes(
  `${prefix}/FETCH_BUILDING_PERMIT_IMPORT_UNMATCHED`,
);

export const fetchBuildingPermitImportUnmatched = makeApiActionCreatorV3(
  api.fetchBuildingPermitImportUnmatched,
  FETCH_BUILDING_PERMIT_IMPORT_UNMATCHED[START],
  FETCH_BUILDING_PERMIT_IMPORT_UNMATCHED[SUCCESS],
  FETCH_BUILDING_PERMIT_IMPORT_UNMATCHED[ERROR],
);
